import { render, staticRenderFns } from "./BusinessCoefficientCreate.vue?vue&type=template&id=6e757aa4"
import script from "./BusinessCoefficientCreate.vue?vue&type=script&lang=js"
export * from "./BusinessCoefficientCreate.vue?vue&type=script&lang=js"
import style0 from "./BusinessCoefficientCreate.vue?vue&type=style&index=0&id=6e757aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports